export default __webpack_public_path__ + "static/media/mumbai.751c4c6b.png";